import React, {Component} from 'react';
import up from '../icons/red_chevron.png';
import down from '../icons/green_chevron.png';
import styles from '../Calculator.scss';

export default class CompareButtons extends Component {
  compare = () => {
    let kingstonData = this.props.kingstonData;
    let cityData = this.props.selectedCityData;
    let difference = undefined;
    difference = ((cityData - kingstonData)/cityData)*100;
    return difference = Math.round(difference);
  }

  render(){
    var difference = this.compare()
    if (difference < 0){
      return(
        <img src={up} alt="green arrow" className={styles.chevron}/>
    );
    } else {
      return(
        <img src={down} alt="red arrow" className={styles.chevron}/>
    );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Calculator/sections/CompareButtons.js